module.exports = __webpack_public_path__ + "static/screenshot-c6e82d4da78ca7731c708bf83465b86d.png";